import { Typography, Button } from "@mui/material";
import { Link } from "react-router-dom";
import StyledBox from "../styled/styledBox";
import React from "react";

const WelcomeStepTwo = (): React.JSX.Element => (
  <StyledBox>
    <Typography variant="h5" color="initial" sx={{ mb: 2, fontWeight: "bold" }}>
      Schritt 2.
    </Typography>

    <Typography
      variant="body1"
      color="primary"
      sx={{ mb: 2, fontWeight: "bold" }}
    >
      Buche deine Termine
    </Typography>

    <Typography variant="body1" color="initial" sx={{ mb: 2 }}>
      Um lange Wartezeiten zwischen den Terminen zu verhindern, buche möglichst
      gleich zwei Termine mit einigen Tagen Abstand.
    </Typography>

    <Link
      to={"/booking"}
      style={{
        textAlign: "center",
        width: "100%",
      }}
    >
      <Button fullWidth variant="contained" color="secondary">
        Coaching buchen
      </Button>
    </Link>
  </StyledBox>
);

export default WelcomeStepTwo;
